(function () {

    'use strict';
    angular.module('app').controller('selectWorkbooksOrganisationController', ['$scope', '$uibModalInstance', 'workbooksService', selectWorkbooksOrganisationController]);

    function selectWorkbooksOrganisationController($scope, $uibModalInstance, workbooksService) {

        $scope.model = {};
        $scope.model.working = false;
        $scope.model.filter = {
            name: '',
            page: 0,
            take: 10
        };

        $scope.searchWorkbooksOrganisations = function () {
            $scope.model.working = true;

            workbooksService.searchOrganisations($scope.model.filter).then(function (organisations) {
                $scope.model.working = false;
                $scope.model.organisations = organisations;
            });
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.pageChanged = function() {
            $scope.searchWorkbooksOrganisations();
        };

        $scope.selectOrganisation = function (organisation) {
            $uibModalInstance.close(organisation);
        };
    }
})();